module.exports = __webpack_public_path__ + "static/media/matilde-special-crown-sleepy.af457261.png";